
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Text } from "@chakra-ui/react";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Text textStyle="paragraph-sm" mdxType="Text">
  Vous trouverez ci-après toutes les catégories des héritières et héritiers
  Sélectionnez les personnes qui vous survivent.
    </Text>
    <Text textStyle="paragraph-sm" mdxType="Text">
  Je laisse les héritières et héritiers suivants:
    </Text>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;